// extracted by mini-css-extract-plugin
export default {"gallery":"hTu3t","grid":"bp4_m","imageWrapper":"gcva8","image":"DfybG","slide":"JBZI1"};